module.exports = __webpack_public_path__ + "static/media/unidentified_customer.6dafe5af.svg";